import ReactMarkdown from "react-markdown";

export const Markdown = ({ children }: { children: string }) => {
  return (
    <ReactMarkdown
      components={{
        p: ({ children, ...props }) => (
          <p className="mt-1 mb-2" {...props}>
            {children}
          </p>
        ),
        li: ({ children, ...props }) => (
          <li className="mt-1 mb-2" {...props}>
            {children}
          </li>
        ),
        ol: ({ children, ...props }) => (
          <ol className="list-decimal pl-6 pb-2" {...props}>
            {children}
          </ol>
        ),
        ul: ({ children, ...props }) => (
          <ul className="list-disc pl-6" {...props}>
            {children}
          </ul>
        ),
        h1: ({ children, ...props }) => (
          <h1 className="text-2xl font-bold" {...props}>
            {children}
          </h1>
        ),
        h2: ({ children, ...props }) => (
          <h2 className="text-xl font-bold" {...props}>
            {children}
          </h2>
        ),
        h3: ({ children, ...props }) => (
          <h3 className="text-lg font-bold" {...props}>
            {children}
          </h3>
        ),
        h4: ({ children, ...props }) => (
          <h4 className="text-md font-bold" {...props}>
            {children}
          </h4>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
};
